import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { Customer } from 'src/model/customer.model';
import { User } from 'src/model/user.model';
import { CompanyService } from 'src/services/company.service';
import { CustomerService } from 'src/services/customer.service';
import { ProfileService } from 'src/services/profile.service';
import { UserService } from 'src/services/user.service';

@Component({
    selector: 'app-add-customer',
    templateUrl: './add-customer.component.html',
    styleUrls: ['./add-customer.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class AddCustomerComponent implements OnInit {
  private router = inject(Router);
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private customerService = inject(CustomerService);
  private profileService = inject(ProfileService);
  private companyService = inject(CompanyService);
  private userService = inject(UserService);

  today: any;
  public imagePath;
  imgURL: any;
  imageUrls: string[];

  customer: Customer = new Customer();

  customerNameNull = false;
  icNumberNull = false;
  contactNoNull = false;
  custOccupationNull = false;
  salaryAmountNull = false;
  salaryDayNull = false;
  remarkNull = false;
  addressNull = false;
  genderNull = false;
  raceNull = false;

  @Output() passEntry = new EventEmitter<any>();

  disabledSubmit = false;

  selectedCompany: number;
  selectedCompanyCode: string;
  isCPCustomer = false;
  companyList: Company[] = [];
  userList: User[] = [];
  selectedUsername: string;

  myControl = new UntypedFormControl();
  filteredCompany: Observable<Company[]>;

  constructor() {
    //filter company
    this.filteredCompany = this.myControl.valueChanges.pipe(
      startWith(''),
      map(companyCode => this._filterCompanyCodeOptions(companyCode))
    );
  }

  ngOnInit() {
    if (this.sharedService.isBossAccount())
      this.getAllCompanies();
  }

  getToday() {
    this.today = new Date().toISOString().substr(0, 10);
    return this.today;
  }

  private _filterCompanyCodeOptions(value: string): Company[] {
    const filterValue = value.toLowerCase();

    // return this.companyList.filter(company => company.CompanyCode.toLowerCase().includes(filterValue));
    // var filtered = this.companyList.filter(company => { return company.CompanyCode.toLowerCase().indexOf(filterValue) === 0 });
    const filtered = this.companyList.filter(company => { return company.CompanyCode.toLowerCase().includes(filterValue) });

    return filtered;
  }

  async getAllCompanies() {
    //clear company list
    this.companyList.splice(0, this.companyList.length);
    this.companyList = await this.companyService.getAllCompanies();
    if (this.selectedCompany != undefined)
      this.setSelectedCompanyCode(this.selectedCompany);
  }

  async getAllUsersOfCompany(companyId: number) {
    this.companyList.splice(0, this.companyList.length);
    this.userList = await this.userService.getAllUsers({ companyId: companyId });
  }

  setSelectedCompanyCode(companyId: number) {
    const index = this.companyList.findIndex(company => Number(company.ID) == Number(companyId));
    this.selectedCompanyCode = this.companyList[index].CompanyCode;
  }

  setSelectedCompany(code: string) {
    const index = this.companyList.findIndex(company => company.CompanyCode.toLowerCase() == code.toLowerCase());
    this.selectedCompany = this.companyList[index].ID;

    this.getAllUsersOfCompany(this.companyList[index].ID);
  }

  confirmBeforeGoToCustomer(id: string, customerId: string, ic: string, code: string) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Customer with IC NUMBER : " + ic + " and CODE: " + code + " already existed in system. You want to go to the profile?";

    modalRef.result.then((confirm) => {
      if (confirm) {
        this.router.navigate(['/manageCustomer', customerId, id]);
        this.activeModal.close();
      }
    });
  }

  validField(field: string) {
    switch (field) {
      case 'customerName': this.customerNameNull = (this.customer.Name === ''); break;
      case 'icNumber': this.icNumberNull = (this.customer.ICNumber === ''); break;
      case 'contactNo': this.contactNoNull = (this.customer.ContactNo === ''); break;
      case 'custOccupation': this.custOccupationNull = (this.customer.Occupation === ''); break;
      case 'salaryAmount': this.salaryAmountNull = (this.customer.Salary === 0); break;
      case 'salaryDay': this.salaryDayNull = (this.customer.SalaryDay === 0); break;
      case 'remark': this.remarkNull = (this.customer.Remark === ''); break;
      case 'address': this.addressNull = (this.customer.Address === ''); break;
      case 'dob': this.customer.DOB == undefined; break;
    }
  }

  validFields() {
    this.customerNameNull = (this.customer.Name == undefined || this.customer.Name === '');
    this.icNumberNull = (this.customer.ICNumber == undefined || this.customer.ICNumber === '');
    this.remarkNull = (this.customer.Remark == undefined || this.customer.Remark === '');
    const customerCodeNull = (this.customer == undefined || this.customer.Name === '');

    this.contactNoNull = (this.customer.ContactNo == undefined || this.customer.ContactNo === '');
    this.custOccupationNull = (this.customer.Occupation == undefined || this.customer.Occupation === '');
    this.salaryAmountNull = (this.salaryAmountNull == undefined);
    this.salaryDayNull = (this.customer.SalaryDay == undefined || this.customer.SalaryDay === 0);

    this.addressNull = (this.customer.Address == undefined || this.customer.Address === '');

    const salaryDayInvalid = (this.customer.SalaryDay < 1 || this.customer.SalaryDay > 31);

    if (this.icNumberNull == false) {
      var icNumberInvalid = !this.sharedService.checkIfICValid(this.customer.ICNumber);
    }

    const cpCompanyNull = (this.isCPCustomer == true && this.customer == undefined);
    const cpStaffNull = (this.isCPCustomer == true && this.customer.HandlerId == undefined);

    const dobNull = (this.customer.DOB == undefined);

    const genderNull = (this.customer.Gender == "" || this.customer.Gender == undefined)
    const raceNull = (this.customer.Race == "" || this.customer.Race == undefined)
    const dobInvalid = this.sharedService.checkInvalidCustomerAge(this.customer.DOB);

    // console.log("customerName" + this.customerNameNull)
    // console.log("icNumberNull" + this.icNumberNull)
    // console.log("icNumberInvalid" + icNumberInvalid)
    // console.log("customerCodeNull" + customerCodeNull)
    // console.log("cpCompanyNull" + cpCompanyNull)
    // console.log("cpStaffNull" + cpStaffNull)
    // console.log("dobNull" + dobNull)
    // console.log("genderNull" + this.genderNull)
    // console.log("raceNull" + this.raceNull)

    if (this.isCPCustomer == true)
      return (this.customerNameNull || this.icNumberNull || icNumberInvalid || customerCodeNull || cpCompanyNull || cpStaffNull || dobNull || genderNull || raceNull);
    else {
      return (this.customerNameNull || this.icNumberNull
        || this.custOccupationNull || this.salaryAmountNull || salaryDayInvalid || icNumberInvalid || this.addressNull || customerCodeNull || dobNull || dobInvalid || genderNull || raceNull);
    }
  }

  handleFileInput(fileList: FileList) {
    this.imageUrls = [];

    Array.from(fileList).forEach((file: File) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result);
        this.imageUrls.push(result);
      }
      reader.readAsDataURL(file);
    });
  }

  reset() {
    this.imageUrls = null;

    this.activeModal.close();
    this.customer.Name = "";
    this.customer.Occupation = "";
    this.customer.ContactNo = "";
    this.customer.Salary = 0;
    this.customer.SalaryDay = 0;
    this.customer.ICNumber = "";
    this.customer.Remark = "";
    this.customer.Address = "";
    this.customer.DOB = undefined;
  }

  checkIfSalaryDateInvalid() {
    if (this.customer.SalaryDay != undefined) {
      if (this.customer.SalaryDay > 31 || this.customer.SalaryDay < 0)
        return true;
      else
        return false;
    }
  }

  submit() {
    this.validFields() ? this.sharedService.openAlert('Please fill in all the fields correctly!', ALERT_TYPE.DANGER) : this.addCustomer();
  }

  async addCustomer() {
    this.disabledSubmit = true;
    const companyId = Number(sessionStorage.getItem('companyId'));
    const loggedInUsername = sessionStorage.getItem('username');

    this.customer.DateCreated = new Date();
    if (this.isCPCustomer !== true) {
      this.customer.CompanyId = companyId;
      this.customer.HandlerId = loggedInUsername;
    }

    try {
      if (this.isCPCustomer)
        this.customer.CompanyId = this.selectedCompany;

      await this.customerService.postCustomer(this.customer, this.isCPCustomer);
      this.passEntry.emit(true);
      this.reset();
      this.sharedService.openAlert("Successfully added customer!", ALERT_TYPE.SUCCESS);
    } catch (error) {
      if (error.status == 409) {
        const a = await this.profileService.getCheckCustomerExisted(this.customer.ICNumber, this.customer.CustomerCode);
        this.confirmBeforeGoToCustomer(String(a.ID), String(a.CustomerID), this.customer.ICNumber, this.customer.CustomerCode);
      }
    } finally {
      this.disabledSubmit = false;
    }
  }
}